
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/giveaway/[slug]",
      function () {
        return require("private-next-pages/d/giveaway/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/giveaway/[slug]"])
      });
    }
  